<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <circle cx="4.5" cy="4.5" r="4" stroke="#B7B7B7"/>
    <path d="M3 3.68164L4.5 5.18164L7 2.68164" stroke="#B7B7B7"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconClock'
}
</script>
